var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-modal',{ref:"modal",attrs:{"title":'Existing Fee Selection',"size-class":'modal-lg'}},[_c('fee-selection',{ref:"feeSelection",attrs:{"consultant-id":_vm.consultantId},on:{"onFeeSelected":_vm.feeSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }